import { writable } from 'svelte/store';
export const monster = writable(null);
